import { taxReturnsBaseUrl } from 'app/http/apiRoutes';
import httpApiApplication from 'app/http/httpApiApplication';

import { type TaxReturn } from '../types';

export const baseUrlTaxreturns = taxReturnsBaseUrl;

export const taxReturnService = {
  getTaxReturn: async (id: string): Promise<TaxReturn> => {
    return httpApiApplication.get(baseUrlTaxreturns + '/' + id);
  }
};
